import type { OpenAPI } from "../../interfaces";

export const tags = (api) => ({
  getAll(
    includeCounts = true,
    success: (data: OpenAPI.GET<"/tags">["response"]) => void,
    fail,
  ) {
    api.maybeAuthenticatedRequest(
      "GET",
      `/tags?includeCounts=${includeCounts}`,
      null,
      success,
      fail,
    );
  },
  getAllForEntity(
    forType: string,
    forId: string,
    includeCounts = true,
    success: (
      data: OpenAPI.GET<"/tags/entity/{for_type}/{for_id}">["response"],
    ) => void,
    fail,
  ) {
    api.maybeAuthenticatedRequest(
      "GET",
      `/tags/entity/${forType}/${forId}?includeCounts=${includeCounts}`,
      null,
      success,
      fail,
    );
  },
  create(
    value: string,
    success: (data: OpenAPI.POST<"/tags">["response"]) => void,
    fail,
  ) {
    api.maybeAuthenticatedRequest("POST", "/tags", { value }, success, fail);
  },
  bulkCreate(
    values: string[],
    success: (data: OpenAPI.POST<"/tags/bulk">["response"]) => void,
    fail,
  ) {
    api.maybeAuthenticatedRequest(
      "POST",
      "/tags/bulk",
      { values },
      success,
      fail,
    );
  },
  reset(
    values: string[],
    success: (data: OpenAPI.POST<"/tags/reset">["response"]) => void,
    fail,
  ) {
    api.maybeAuthenticatedRequest(
      "POST",
      `/tags/reset`,
      { values },
      success,
      fail,
    );
  },
  search(
    value: string,
    success: (data: OpenAPI.GET<"/tags/search/{value}">["response"]) => void,
    fail,
  ) {
    api.maybeAuthenticatedRequest(
      "GET",
      `/tags/search/${value}`,
      null,
      success,
      fail,
    );
  },
  searchWithOptions(
    value: string,
    organisation: string,
    limit: number,
    exclude: string[],
    success: (data: OpenAPI.GET<"/tags/search/{value}">["response"]) => void,
    fail,
  ) {
    api.maybeAuthenticatedRequest(
      "GET",
      `/tags/search/${value}?organisation=${organisation}&limit=${limit}&${exclude.map((e) => `exclude=${e}`).join("&")}`,
      null,
      success,
      fail,
    );
  },
  get(
    id: string,
    success: (data: OpenAPI.GET<"/tags/{id}">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest("GET", `/tags/${id}`, null, success, fail);
  },
  update(
    id: string,
    data: OpenAPI.POST<"/tags/{id}">["requestBody"],
    success: (data: OpenAPI.POST<"/tags/{id}">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest("PUT", `/tags/${id}`, data, success, fail);
  },
  delete(
    id: string,
    success: (data: OpenAPI.DELETE<"/tags/{id}">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest("DELETE", `/tags/${id}`, null, success, fail);
  },
  full(
    tagIds: string[],
    success: (data: OpenAPI.GET<"/tags/full">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "GET",
      `/tags/full?${tagIds.map((t) => `tagId=${t}`).join("&")}`,
      null,
      success,
      fail,
    );
  },
  tagDocuments(
    tagType: string,
    tagIds: string[],
    documents: string[],
    success: (data: OpenAPI.POST<"/tags/{tag_type}/tag">["response"]) => void,
    fail,
  ) {
    api.maybeAuthenticatedRequest(
      "POST",
      `/tags/${tagType}/tag`,
      { tags: tagIds, documents },
      success,
      fail,
    );
  },
  tagSingle(
    tagType: string,
    tagId: string,
    objectId: string,
    success: (
      data: OpenAPI.POST<"/tags/{tag_type}/tag">["response"][number],
    ) => void,
    fail,
  ) {
    api.tags.tagDocuments(
      tagType,
      [tagId],
      [objectId],
      (updatedTags) => success(updatedTags[0]),
      fail,
    );
  },
  untagDocuments(
    tagType: string,
    tagIds: string[],
    documents: string[],
    success: (data: OpenAPI.POST<"/tags/{tag_type}/tag">["response"]) => void,
    fail,
  ) {
    api.maybeAuthenticatedRequest(
      "DELETE",
      `/tags/${tagType}/tag`,
      { tags: tagIds, documents },
      success,
      fail,
    );
  },
  untagSingle(
    tagType: string,
    tagId: string,
    objectId: string,
    success: (
      data: OpenAPI.POST<"/tags/{tag_type}/tag">["response"][number],
    ) => void,
    fail,
  ) {
    api.tags.untagDocuments(
      tagType,
      [tagId],
      [objectId],
      (updatedTags) => success(updatedTags[0]),
      fail,
    );
  },
});
